import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../client";
import { FaPlus, FaTrash, FaCheck, FaUser, FaClock } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import confetti from 'canvas-confetti';
import Navbar from "../components/Navbar";
import ChatUI from "../components/ChatUI";
import chatService from "../services/chatService";

// Add this CSS to your stylesheet
const responsiveStyles = `
.dashboard-responsive-container {
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
}

.planner-dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.dashboard-main {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.events-calendar-row {
  display: flex; /* This remains for mobile-first */
  flex-direction: column;
  gap: 2rem;
}

.welcome-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
  margin-bottom: 2rem;
}

.tasks-section, .chat-section {
  width: 100%;
}

/* Tablet (768px and up) - SWITCH TO CSS GRID */
@media (min-width: 768px) {
  .dashboard-responsive-container {
    max-width: 720px;
    padding: 0 2rem;
  }
  
  .welcome-section {
    flex-direction: row;
    text-align: left;
    align-items: center;
  }
  
  .events-calendar-row {
    display: grid; /* USE GRID FOR A MORE ROBUST LAYOUT */
    grid-template-columns: 1fr 1fr; /* CREATE TWO EQUAL COLUMNS */
    gap: 2rem;
  }
}

/* Desktop (1024px and up) */
@media (min-width: 1024px) {
  .dashboard-responsive-container {
    max-width: 1250px;
  }
  
  /* The grid columns from the tablet view will apply, so no need to redefine them unless you want different proportions */
}

/* Mobile optimizations */
@media (max-width: 767px) {
  .planner-dashboard {
    padding: 60px 0 0 0 !important;
  }
  
  .dashboard-responsive-container > div {
    margin: 10px auto 0 !important;
    padding: 1rem !important;
    border-radius: 20px !important;
  }
  
  .events-scroll-container {
    max-height: 300px !important;
    min-height: 200px !important;
  }
}

/* Ensure images are responsive */
img {
  max-width: 100%;
  height: auto;
}

/* Improve scroll areas */
.events-scroll-container {
  overflow-y: auto;
}

/* Calendar responsive fixes */
.react-calendar {
  width: 100% !important;
}

/* Mobile first approach for all elements */
@media (max-width: 480px) {
  .welcome-section {
    gap: 1rem;
  }
  
  .welcome-section h1 {
    font-size: 1.5rem !important;
  }
  
  .welcome-section p {
    font-size: 0.9rem !important;
  }
}
  /* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  max-width: 400px;
  width: 90%;
  text-align: center;
  position: relative;
}

.modal-close-x-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.modal-close-x-btn:hover {
  color: #333;
}
`;

// Add the styles to the document head
const styleSheet = document.createElement("style");
styleSheet.innerText = responsiveStyles;
document.head.appendChild(styleSheet);

const SuccessModal = ({ message, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-x-btn">
          &times;
        </button>
        <p>{message}</p>
        <button
          onClick={onClose}
          style={{
            marginTop: "1.5rem",
            backgroundColor: "#E8B180",
            color: "white",
            border: "none",
            padding: "0.75rem 1.5rem",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "500",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#D89F73")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#E8B180")
          }
        >
          OK
        </button>
      </div>
    </div>
  );
};

// Confirmation Modal Component
const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginTop: 0, color: "#333" }}>Confirm Deletion</h3>
        <p
          style={{
            margin: "1rem 0",
            fontSize: "1rem",
            color: "#666",
            lineHeight: "1.5",
          }}
        >
          {message}
        </p>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "center",
            marginTop: "1.5rem",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              backgroundColor: "#6c757d",
              color: "white",
              border: "none",
              padding: "0.75rem 1.5rem",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "500",
              transition: "background-color 0.2s",
              flex: 1,
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#5a6268")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#6c757d")
            }
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              border: "none",
              padding: "0.75rem 1.5rem",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "500",
              transition: "background-color 0.2s",
              flex: 1,
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#c82333")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#dc3545")
            }
          >
            Delete Event
          </button>
        </div>
      </div>
    </div>
  );
};

export default function PlannerDashboard({ session }) {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("Planner");
  const [preview, setPreview] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  // Tasks state
  const [tasks, setTasks] = useState([]);
  const [events, setEvents] = useState([]);
  const [newTask, setNewTask] = useState("");
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [chatMessages, setChatMessages] = useState({});
  const [, setConversations] = useState([]);
  const [conversationItems, setConversationItems] = useState([]);
  const [currentConversation, setCurrentConversation] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [eventToDelete, setEventToDelete] = useState(null);
  const [confirmModalMessage, setConfirmModalMessage] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  // Load conversations for the planner
  const loadConversations = useCallback(async () => {
    if (!session?.user) return;

    try {
      const conversations = await chatService.getUserConversations(
        session.user.id
      );
      setConversations(conversations);
      // Map conversations to sidebar items (counterparty for the planner)
      const items = (conversations || []).map((c) => {
        const business = c.vendor?.business_name;
        const person = c.vendor?.name || c.planner?.name;
        const counterpartyName =
          business && person
            ? `${business} — ${person}`
            : business || person || "Conversation";
        return {
          id:
            c.vendor_id && session.user.id === c.planner_id
              ? c.vendor_id
              : c.planner_id,
          name: counterpartyName,
          conversation_id: c.conversation_id,
          lastMessage: c.last_message_text || "",
          unread: 0,
        };
      });
      setConversationItems(items);
    } catch (error) {
      console.error("Error loading conversations:", error);
    }
  }, [session?.user]);

  // Load unread message count
  const loadUnreadCount = useCallback(async () => {
    if (!session?.user) return;

    try {
      const count = await chatService.getUnreadCount(session.user.id);
      setUnreadCount(count);
    } catch (error) {
      console.error("Error loading unread count:", error);
    }
  }, [session?.user]);

  // Initialize chat service and set up real-time listeners
  useEffect(() => {
    if (session?.user) {
      const WS_URL = process.env.REACT_APP_API_URL;
      // Connect to chat service
      chatService.connect(session.user.id, WS_URL);

      // Set up real-time listeners
      chatService.onNewMessage((message) => {
        console.log("New message received:", message);

        // Update messages for the conversation
        setChatMessages((prev) => {
          const conversationId = message.conversation_id;
          return {
            ...prev,
            [conversationId]: [
              ...(prev[conversationId] || []),
              {
                id: message.message_id,
                text: message.message_text,
                timestamp: message.created_at,
                isCurrentUser: message.sender_id === session.user.id,
                sender: message.sender?.name || "Unknown",
                conversationId: message.conversation_id,
              },
            ],
          };
        });
      });

      chatService.onMessageError((error) => {
        console.error("Message error:", error);
        // You could show a toast notification here
      });

      chatService.onMessageNotification((notification) => {
        console.log("Message notification:", notification);
        // Update unread count or show notification
        setUnreadCount((prev) => prev + 1);
      });

      // Load conversations and unread count
      loadConversations();
      loadUnreadCount();
    }

    return () => {
      chatService.removeAllListeners();
    };
  }, [session?.user, loadConversations, loadUnreadCount]);

  // Handle sending a message
  const handleSendMessage = async (message) => {
    if (!currentConversation || !session?.user) return;

    try {
      // Send message via WebSocket for real-time delivery
      chatService.sendMessage(
        currentConversation.conversation_id,
        session.user.id,
        message.text,
        "text"
      );

      // Also send via API as backup
      await chatService.sendMessageAPI(
        currentConversation.conversation_id,
        session.user.id,
        message.text,
        "text"
      );

      // Update local state immediately for better UX
      setChatMessages((prev) => ({
        ...prev,
        [currentConversation.conversation_id]: [
          ...(prev[currentConversation.conversation_id] || []),
          {
            ...message,
            conversationId: currentConversation.conversation_id,
          },
        ],
      }));
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  // Handle vendor selection and load conversation
  const handleSelectVendor = async (vendor) => {
    if (!session?.user) return;

    setSelectedVendor(vendor);

    try {
      // Get or create conversation with the vendor
      const conversation = await chatService.getOrCreateConversation(
        session.user.id,
        vendor.id
      );

      setCurrentConversation(conversation);

      // Join the conversation room for real-time updates
      chatService.joinConversation(conversation.conversation_id);

      // Load messages for this conversation
      const messages = await chatService.getConversationMessages(
        conversation.conversation_id
      );

      // Transform messages to match ChatUI format
      const formattedMessages = messages.map((msg) => ({
        id: msg.message_id,
        text: msg.message_text,
        timestamp: msg.created_at,
        isCurrentUser: msg.sender_id === session.user.id,
        sender: msg.sender?.name || "Unknown",
      }));

      setChatMessages((prev) => ({
        ...prev,
        [conversation.conversation_id]: formattedMessages,
      }));

      // Mark messages as read
      await chatService.markMessagesAsRead(
        conversation.conversation_id,
        session.user.id
      );
    } catch (error) {
      console.error("Error selecting vendor:", error);
    }
  };

  console.log("Current URL:", window.location.href);
  console.log("Using API_URL:", API_URL);
  // Prevent scrolling until page is fully loaded
  useLayoutEffect(() => {
    // Add a class to the body to prevent scrolling via CSS
    document.body.classList.add("dashboard-loading");

    // Lock scroll on mount
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    // Scroll to top immediately
    window.scrollTo(0, 0);

    // Re-enable scrolling after a longer delay (1000ms)
    const timer = setTimeout(() => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
      document.body.classList.remove("dashboard-loading");
      window.scrollTo(0, 0);
    }, 1000);

    // Cleanup
    return () => {
      clearTimeout(timer);
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
      document.body.classList.remove("dashboard-loading");
    };
  }, []);

  useEffect(() => {
    if (!session?.user) {
      setLoading(false);
      return;
    }

    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${API_URL}/api/planners/${session.user.id}`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          const textResponse = await response.text();
          console.error(
            "Server returned HTML instead of JSON:",
            textResponse.substring(0, 200)
          );
          throw new Error("Server returned non-JSON response");
        }

        if (!response.ok) throw new Error("Failed to fetch planner data");

        const data = await response.json();
        setUserName(data.name || session.user.email.split("@")[0]);
        setPreview(data.profile_picture || null);
      } catch (err) {
        console.error("Error fetching user data:", err);
        setUserName(session.user.email?.split("@")[0] || "Planner");
        setPreview(null);
      }
    };

    const fetchEventsFromAPI = async () => {
      try {
        const response = await fetch(
          `${API_URL}/api/events?planner_id=${session.user.id}`,
          {
            cache: "no-store",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Server returned non-JSON response");
        }

        if (!response.ok) throw new Error("Failed to fetch events");

        const data = await response.json();
        setEvents(data);
      } catch (err) {
        console.error("Error fetching events from API:", err);
      }
    };

    const fetchTasks = async () => {
      try {
        const { data, error } = await supabase
          .from("tasks")
          .select("*")
          .eq("planner_id", session.user.id)
          .order("created_at", { ascending: false });

        if (error) throw error;

        const formattedTasks = data.map((task) => ({
          id: task.task_id,
          text: task.item,
          completed: task.completed || false,
          created_at: task.created_at,
        }));

        setTasks(formattedTasks);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
    fetchEventsFromAPI();
    fetchTasks();
  }, [session, API_URL]); // Added API_URL to dependency array

  const confirmDeleteEvent = (eventId, eventName) => {
    setEventToDelete(eventId);
    setConfirmModalMessage(
      `Are you sure you want to delete "${eventName}"? This action cannot be undone.`
    );
    setShowConfirmModal(true);
  };

  // Function to actually delete the event
  const deleteEvent = async () => {
    if (!eventToDelete) return;

    try {
      const response = await fetch(`${API_URL}/api/events/${eventToDelete}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to delete event");
      }

      // Remove the event from local state
      setEvents((prevEvents) =>
        prevEvents.filter((event) => event.event_id !== eventToDelete)
      );

      // Show success modal
      setModalMessage("Event deleted successfully!");
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error deleting event:", error);
      setModalMessage(`Error deleting event: ${error.message}`);
      setShowSuccessModal(true);
    } finally {
      // Reset confirmation modal state
      setShowConfirmModal(false);
      setEventToDelete(null);
    }
  };

  const handleAddTask = async (e) => {
    e.preventDefault();
    if (!newTask.trim() || !session?.user?.id) {
      console.error("Missing required fields:", {
        hasText: !!newTask.trim(),
        hasUserId: !!session?.user?.id,
      });
      return;
    }

    try {
      // Get current auth session to verify user is authenticated
      const {
        data: { user },
        error: authError,
      } = await supabase.auth.getUser();

      if (authError || !user) {
        console.error("Authentication error:", authError || "No user found");
        throw new Error("Not authenticated");
      }

      console.log("Current user:", { id: user.id, email: user.email });

      const taskData = {
        planner_id: user.id, // Use the ID from the auth session
        item: newTask.trim(),
        completed: false,
      };

      console.log("Attempting to add task with data:", taskData);

      // Verify table access by making a test query
      const { error: testError } = await supabase
        .from("tasks")
        .select("*")
        .limit(1);

      if (testError) {
        console.error("Test query failed:", testError);
        throw testError;
      }

      // Proceed with insert
      const { data, error } = await supabase
        .from("tasks")
        .insert([taskData]) // Note: Changed to array format which is required by Supabase
        .select();

      if (error) {
        console.error("Supabase insert error details:", {
          message: error.message,
          details: error.details,
          hint: error.hint,
          code: error.code,
        });
        throw error;
      }

      console.log("Task added successfully:", data);

      if (data && data.length > 0) {
        const newTaskItem = {
          id: data[0].id || data[0].task_id, // Try both possible ID fields
          text: data[0].item,
          completed: data[0].completed || false,
          created_at: data[0].created_at || new Date().toISOString(),
        };

        setTasks((prevTasks) => [newTaskItem, ...prevTasks]);
        setNewTask("");
      }
    } catch (error) {
      console.error("Error adding task:", error);
    }
  };

  const toggleTaskCompletion = async (taskId, completed) => {
    const isCompleting = !completed; // Check if we're marking as complete (true) or incomplete (false)
    
    try {
      const { error } = await supabase
        .from("tasks")
        .update({ completed: isCompleting })
        .eq("task_id", taskId);

      if (error) throw error;

      setTasks(
        tasks.map((task) =>
          task.id === taskId ? { ...task, completed: isCompleting } : task
        )
      );

      // Trigger confetti only when marking a task as complete (not when unchecking)
      if (isCompleting) {
        // Create a basic confetti effect
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
          colors: ['#FFB6C1', '#FFD700', '#87CEEB', '#98FB98', '#FFA07A'],
        });

        // Add a slight delay and trigger another burst
        setTimeout(() => {
          confetti({
            particleCount: 50,
            spread: 100,
            origin: { y: 0.5 },
            colors: ['#FFB6C1', '#FFD700', '#87CEEB'],
          });
        }, 300);
      }
    } catch (error) {
      console.error("Error updating task:", error);
    }
  };

  const deleteTask = async (taskId) => {
    try {
      const { error } = await supabase
        .from("tasks")
        .delete()
        .eq("task_id", taskId);

      if (error) throw error;

      setTasks(tasks.filter((task) => task.id !== taskId));
    } catch (error) {
      console.error("Error deleting task:", error);
    }
  };

  const handleAddEvent = (e) => {
    e.preventDefault();
    navigate("/add-event");
  };

  // Loading state
  if (loading) {
    return (
      <div
        className={`dashboard-container ${loading ? "dashboard-loading" : ""}`}
        style={{
          padding: "1.5rem",
          maxWidth: "1200px",
          margin: "0 auto",
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "2rem",
            borderRadius: "8px",
            backgroundColor: "white",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <div
            className="spinner"
            style={{
              width: "40px",
              height: "40px",
              margin: "0 auto 1rem",
              border: "4px solid #FFF0F5",
              borderTop: "4px solid #FFB6C1",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
          <h3 style={{ color: "#FFB6C1" }}>Loading your dashboard...</h3>
        </div>
      </div>
    );
  }

  const formatTime = (dateString) => {
    if (!dateString) return "Time not set";
    const date = new Date(dateString);
    return date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Format date to display in a readable format
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Add this function to check if an event is in the future
  const isFutureEvent = (eventDate) => {
    const now = new Date();
    const eventDateTime = new Date(eventDate);
    return eventDateTime > now;
  };

  // Get only future events
  const getUpcomingEvents = () => {
    return events.filter(
      (event) => event.start_time && isFutureEvent(event.start_time)
    );
  };

  // Get events for the selected date
  const getEventsForDate = (date) => {
    return events.filter((event) => {
      const eventDate = new Date(event.start_time);
      return eventDate.toDateString() === date.toDateString();
    });
  };

  return (
    <div
      className="planner-dashboard"
      style={{
        minHeight: "100vh",
        background: "radial-gradient(circle at 100% 0%, #FFE4C4, #FFB6C1)",
        padding: "80px 0 0 0",
        boxSizing: "border-box",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <Navbar session={session} />
      {showConfirmModal && (
        <ConfirmationModal
          message={confirmModalMessage}
          onConfirm={deleteEvent}
          onCancel={() => {
            setShowConfirmModal(false);
            setEventToDelete(null);
          }}
        />
      )}

      {/* Success/Error Modal */}
      {showSuccessModal && (
        <SuccessModal
          message={modalMessage}
          onClose={() => setShowSuccessModal(false)}
        />
      )}
      {/* Responsive Container */}
      <div className="dashboard-responsive-container">
        <div
          style={{
            backgroundColor: "white",
            minHeight: "calc(100vh - 100px)",
            margin: "20px auto 0",
            borderTopLeftRadius: "30px",
            borderTopRightRadius: "30px",
            padding: "2rem",
            boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <div className="planner-dashboard-content">
            <div className="dashboard-main">
              {/* Welcome Section */}
              <div className="welcome-section">
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    backgroundColor: preview ? "transparent" : "#FFDAB9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    border: "3px solid white",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    cursor: "pointer",
                    transition: "transform 0.2s",
                    flexShrink: 0,
                  }}
                  onClick={() => preview && setShowImageModal(true)}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  {preview ? (
                    <img
                      src={preview}
                      alt="Profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#FFDAB9",
                      }}
                    >
                      <FaUser
                        style={{
                          fontSize: "2.5rem",
                          color: "#FFFFFF",
                          filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.1))",
                          width: "100%",
                          height: "100%",
                          padding: "0.5rem",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <h1
                    style={{
                      fontSize: "2rem",
                      color: "#333",
                      margin: "0 0 0.5rem 0",
                    }}
                  >
                    Welcome back, {userName}!
                  </h1>
                  <p
                    style={{
                      color: "#666",
                      margin: 0,
                      fontSize: "1rem",
                    }}
                  >
                    Here's what's happening with your plans today.
                  </p>
                </div>
              </div>

              {/* Upcoming Events and Calendar Row */}
              <div className="events-calendar-row">
                {/* Upcoming Events Section */}
                <div
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    padding: "1.5rem",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "1.5rem",
                      flexWrap: "wrap",
                      gap: "1rem",
                    }}
                  >
                    <h2 style={{ margin: 0 }}>Upcoming Events</h2>
                    <button
                      onClick={handleAddEvent}
                      style={{
                        backgroundColor: "#E8B180",
                        border: "none",
                        color: "white",
                        padding: "0.6rem 1.2rem",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "500",
                        transition: "all 0.2s",
                        fontSize: "0.9rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        minHeight: "44px",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#D89F73";
                        e.currentTarget.style.transform = "translateY(-1px)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "#E8B180";
                        e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <FaPlus size={14} />
                      Add Event
                    </button>
                  </div>

                  <div
                    style={{
                      flex: "1",
                      paddingRight: "0.5rem",
                      transition: "all 0.3s ease",
                    }}
                    className="events-scroll-container"
                  >
                    {getUpcomingEvents().length === 0 ? (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "2rem",
                          color: "#666",
                        }}
                      >
                        No upcoming events. Add one to get started!
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        {getUpcomingEvents().map((event) => (
                          <div
                            key={event.id}
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              padding: "1rem",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                              transition: "transform 0.2s, box-shadow 0.2s",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                marginBottom: "0.5rem",
                                flexWrap: "wrap",
                                gap: "0.5rem",
                              }}
                            >
                              <h3
                                style={{
                                  margin: 0,
                                  fontSize: "1rem",
                                  color: "#333",
                                  flex: 1,
                                  minWidth: "200px",
                                }}
                              >
                                {event.name}
                              </h3>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "0.5rem",
                                  flexWrap: "wrap",
                                }}
                              >
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/viewEvent/${event.event_id}`);
                                  }}
                                  style={{
                                    backgroundColor: "#FFB6C1",
                                    border: "none",
                                    color: "white",
                                    padding: "0.5rem 1rem",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "0.8rem",
                                    fontWeight: "500",
                                    transition: "all 0.2s",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.25rem",
                                    minHeight: "36px",
                                  }}
                                >
                                  <span>View Details</span>
                                  <span>→</span>
                                </button>

                                {/* DELETE BUTTON */}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    confirmDeleteEvent(
                                      event.event_id,
                                      event.name
                                    );
                                  }}
                                  style={{
                                    backgroundColor: "#ffebee",
                                    border: "none",
                                    color: "#dc3545",
                                    cursor: "pointer",
                                    padding: "0.5rem",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: "36px",
                                    minWidth: "36px",
                                    transition: "background-color 0.2s",
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "#ffcdd2";
                                    e.currentTarget.style.transform =
                                      "scale(1.05)";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "#ffebee";
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                  }}
                                  title="Delete Event"
                                >
                                  <FaTrash size={14} />
                                </button>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#6c757d",
                                fontSize: "0.8rem",
                                marginBottom: "0.2rem",
                                flexWrap: "wrap",
                              }}
                            >
                              <span style={{ marginRight: "0.5rem" }}>📅</span>
                              {formatDate(event.start_time)}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                color: "#6c757d",
                                fontSize: "0.8rem",
                                marginBottom: "0.2rem",
                              }}
                            >
                              <span style={{ marginRight: "0.5rem" }}>🕒</span>
                              {formatTime(event.start_time) || "TBD"}
                            </div>
                            {event.location && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#6c757d",
                                  fontSize: "0.8rem",
                                  marginBottom: "0.2rem",
                                }}
                              >
                                <span style={{ marginRight: "0.5rem" }}>
                                  📍
                                </span>
                                {event.venue || "TBD"}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Calendar Section */}
                <div
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    padding: "1.5rem",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <h2 style={{ marginTop: 0, marginBottom: "1.5rem" }}>
                    Calendar
                  </h2>
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: "16px",
                      padding: "1rem",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    }}
                  >
                    {/* Add the CSS styles directly here */}
                    <style>
                      {`
                      .dashboard-calendar {
                        width: 100%;
                        border: none;
                        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                      }
                      .react-calendar__navigation {
                        display: flex;
                        margin-bottom: 1em;
                      }
                      .react-calendar__navigation button {
                        color: #ff6b8b;
                        background: none;
                        border: none;
                        font-size: 1rem;
                        font-weight: 600;
                        cursor: pointer;
                        padding: 0.5rem;
                        border-radius: 8px;
                        transition: all 0.2s;
                      }
                      .react-calendar__navigation button:hover {
                        background-color: #ffebee;
                      }
                      .react-calendar__navigation button:disabled {
                        background-color: transparent;
                        color: #ccc;
                      }
                      .react-calendar__month-view__weekdays {
                        text-align: center;
                        text-transform: uppercase;
                        font-weight: 600;
                        color: #ff6b8b;
                        font-size: 0.75rem;
                        margin-bottom: 0.5rem;
                      }
                      .react-calendar__month-view__weekdays__weekday abbr {
                        text-decoration: none;
                      }
                      .react-calendar__month-view__weekdays__weekday--weekend abbr {
                        color: #ff6b8b;
                      }
                      .react-calendar__month-view__days__day--weekend {
                        color: #ff6b8b;
                      }
                      .react-calendar__tile {
                        max-width: 100%;
                        text-align: center;
                        padding: 0.75em 0.5em;
                        background: none;
                        border: 2px solid transparent;
                        border-radius: 50%;
                        color: #333;
                        font-weight: 500;
                        transition: all 0.2s;
                        position: relative;
                        overflow: visible;
                        height: 40px;
                      }
                      .react-calendar__tile > div {
                        opacity: 1 !important;
                        visibility: visible !important;
                      }
                      .react-calendar__tile:enabled:hover,
                      .react-calendar__tile:enabled:focus {
                        background-color: #ffebee;
                        border-color: #ffb6c1;
                        transform: scale(1.1);
                      }
                      .react-calendar__tile--now {
                        background: #ffebee;
                        border: 2px solid #ffb6c1;
                        color: #ff6b8b;
                        font-weight: 600;
                      }
                      .react-calendar__tile--now:enabled:hover,
                      .react-calendar__tile--now:enabled:focus {
                        background: #ffd6de;
                        border-color: #ff8fa3;
                      }
                      .react-calendar__tile--active {
                        background: #ffb6c1 !important;
                        color: white !important;
                        border-color: #ffb6c1 !important;
                        font-weight: 600;
                      }
                      .react-calendar__tile--active:enabled:hover,
                      .react-calendar__tile--active:enabled:focus {
                        background: #ffc0cb !important;
                        border-color: #ffc0cb !important;
                      }
                      .react-calendar__month-view__days__day--neighboringMonth {
                        color: #ccc;
                      }
                      
                      /* Fix for event dots - ensure they're positioned correctly */
                      .react-calendar__tile {
                        position: relative;
                      }
                      .event-dots-container {
                        position: absolute;
                        bottom: 2px;
                        left: 50%;
                        transform: translateX(-50%);
                        display: flex;
                        gap: 2px;
                        opacity: 1;
                        visibility: visible;
                      }
                      .event-dot {
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                      }
                      `}
                    </style>
                    <Calendar
                      onChange={setDate}
                      value={date}
                      className="dashboard-calendar"
                      tileContent={({ date, view }) => {
                        const dateEvents = getEventsForDate(date);
                        if (dateEvents.length === 0) return null;

                        return (
                          <div className="event-dots-container">
                            {[...Array(Math.min(3, dateEvents.length))].map(
                              (_, i) => (
                                <div
                                  key={i}
                                  className="event-dot"
                                  style={{
                                    backgroundColor: isFutureEvent(
                                      dateEvents[i]?.start_time
                                    )
                                      ? "#4caf50"
                                      : "#ff6b6b",
                                  }}
                                />
                              )
                            )}
                          </div>
                        );
                      }}
                      formatShortWeekday={(locale, date) =>
                        ["S", "M", "T", "W", "T", "F", "S"][date.getDay()]
                      }
                      next2Label={null}
                      prev2Label={null}
                      minDetail="month"
                      showNeighboringMonth={false}
                    />
                  </div>

                  <div style={{ marginTop: "1.5rem" }}>
                    <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>
                      Events on {date.toLocaleDateString()}
                    </h3>
                    {getEventsForDate(date).length === 0 ? (
                      <p style={{ color: "#6c757d", textAlign: "center" }}>
                        No events scheduled for this day.
                      </p>
                    ) : (
                      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        {getEventsForDate(date).map((event) => {
                          const isPast = !isFutureEvent(event.start_time);
                          return (
                            <li
                              key={event.id}
                              style={{
                                backgroundColor: isPast ? "#f8f9fa" : "white",
                                padding: "0.75rem 1rem",
                                borderRadius: "6px",
                                marginBottom: "0.5rem",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                borderLeft: isPast
                                  ? "3px solid #ff6b6b"
                                  : "3px solid #4caf50",
                                opacity: isPast ? 0.8 : 1,
                              }}
                            >
                              <div style={{ width: "100%" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    marginBottom: "0.25rem",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {isPast && (
                                    <span
                                      style={{
                                        fontSize: "0.65rem",
                                        backgroundColor: "#ffebee",
                                        color: "#d32f2f",
                                        padding: "0.15rem 0.5rem",
                                        borderRadius: "10px",
                                        fontWeight: "500",
                                        flexShrink: 0,
                                      }}
                                    >
                                      Past Event
                                    </span>
                                  )}
                                  <div
                                    style={{
                                      fontWeight: "600",
                                      color: isPast ? "#6c757d" : "#333",
                                      flex: 1,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {event.name || event.title}
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginTop: "0.25rem",
                                    flexWrap: "wrap",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "0.8rem",
                                      color: isPast ? "#adb5bd" : "#6c757d",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.5rem",
                                      flex: 1,
                                    }}
                                  >
                                    <FaClock size={12} />
                                    {formatTime(event.start_time) ||
                                      "Time not set"}
                                  </div>

                                  {isPast && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(
                                          `/viewEvent/${
                                            event.event_id || event.id
                                          }?readonly=true`
                                        );
                                      }}
                                      style={{
                                        fontSize: "0.7rem",
                                        backgroundColor: "transparent",
                                        color: "#e91e63",
                                        border: "1px solid #e91e63",
                                        padding: "0.4rem 0.8rem",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.25rem",
                                        transition: "all 0.2s",
                                        minHeight: "32px",
                                      }}
                                    >
                                      View Details
                                    </button>
                                  )}
                                </div>

                                {event.venue && (
                                  <div
                                    style={{
                                      fontSize: "0.8rem",
                                      color: isPast ? "#adb5bd" : "#6c757d",
                                      marginTop: "0.25rem",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.5rem",
                                    }}
                                  >
                                    <span>📍</span>
                                    {event.venue}
                                  </div>
                                )}
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              {/* Tasks Section */}
              <div
                className="tasks-section"
                style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "12px",
                  padding: "1.5rem",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                <h2 style={{ marginTop: 0, marginBottom: "1.5rem" }}>
                  My To-Do List
                </h2>

                <form
                  onSubmit={handleAddTask}
                  style={{ marginBottom: "1.5rem" }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <input
                      type="text"
                      value={newTask}
                      onChange={(e) => setNewTask(e.target.value)}
                      placeholder="Add a new task..."
                      style={{
                        flex: 1,
                        padding: "0.75rem",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        fontSize: "1rem",
                        minWidth: "200px",
                      }}
                    />
                    <button
                      type="submit"
                      data-testid="add-task-btn" //this is for testing
                      style={{
                        backgroundColor: "#E8B180",
                        color: "white",
                        border: "none",
                        padding: "0 1.5rem",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "500",
                        transition: "background-color 0.2s",
                        minHeight: "44px",
                      }}
                    >
                      Add
                    </button>
                  </div>
                </form>

                <div
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    paddingRight: "0.5rem",
                  }}
                >
                  {tasks.length === 0 ? (
                    <p
                      style={{
                        color: "#6c757d",
                        textAlign: "center",
                        margin: "2rem 0",
                      }}
                    >
                      No tasks yet. Add one above!
                    </p>
                  ) : (
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {tasks.map((task) => (
                        <li
                          key={task.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0.75rem",
                            backgroundColor: task.completed
                              ? "#e8f5e9"
                              : "white",
                            borderRadius: "6px",
                            marginBottom: "0.5rem",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          }}
                        >
                          <button
                            onClick={() =>
                              toggleTaskCompletion(task.id, task.completed)
                            }
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              border: `2px solid ${
                                task.completed ? "#4caf50" : "#ccc"
                              }`,
                              backgroundColor: task.completed
                                ? "#4caf50"
                                : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "1rem",
                              cursor: "pointer",
                              flexShrink: 0,
                            }}
                          >
                            {task.completed && (
                              <FaCheck color="white" size={12} />
                            )}
                          </button>
                          <span
                            style={{
                              flex: 1,
                              textDecoration: task.completed
                                ? "line-through"
                                : "none",
                              color: task.completed ? "#6c757d" : "#212529",
                              wordBreak: "break-word",
                            }}
                          >
                            {task.text}
                          </span>
                          <button
                            data-testid={`delete-task-${task.id}`}
                            onClick={() => deleteTask(task.id)}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#dc3545",
                              cursor: "pointer",
                              marginLeft: "0.5rem",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "0.5rem",
                              borderRadius: "4px",
                              transition: "background-color 0.2s",
                              minWidth: "32px",
                              minHeight: "32px",
                            }}
                          >
                            <FaTrash size={14} />
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {/* Chat Section */}
            <div
              className="chat-section"
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                padding: "1.5rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginTop: "2rem",
              }}
            >
              <ChatUI
                listTitle="Vendors"
                onSendMessage={handleSendMessage}
                onSelectVendor={handleSelectVendor}
                selectedVendor={selectedVendor}
                messages={
                  currentConversation
                    ? chatMessages[currentConversation.conversation_id] || []
                    : []
                }
                unreadCount={unreadCount}
                conversations={conversationItems}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Profile Picture Modal */}
      {showImageModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowImageModal(false)}
        >
          <div
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={preview}
              alt="Profile Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "8px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
              }}
            />
            <button
              onClick={() => setShowImageModal(false)}
              style={{
                position: "absolute",
                top: "-40px",
                right: "0",
                background: "none",
                border: "none",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
                padding: "8px",
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
